import React, { useState, useEffect } from "react";

function LinkWorkOrderModal({ sale, onClose, onSave }) {
  // State for available work order templates
  const [workOrderTemplates] = useState([
    { id: "WO001", name: "Curtains Installation" },
    { id: "WO002", name: "Office Furnishing" },
    { id: "WO003", name: "Furniture Repair" },
    { id: "WO004", name: "Painting Services" },
  ]);

  // State for linked work orders
  const [linkedWorkOrders, setLinkedWorkOrders] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);

  // Synchronize linked work orders with the `sale` prop
  useEffect(() => {
    if (sale) {
      setLinkedWorkOrders(sale.work_orders || []); // Initialize with existing work orders
    }
  }, [sale]);

  // Toggle template selection
  const toggleTemplateSelection = (template) => {
    const isSelected = selectedTemplates.some((t) => t.id === template.id);
    if (isSelected) {
      setSelectedTemplates(selectedTemplates.filter((t) => t.id !== template.id));
    } else {
      setSelectedTemplates([...selectedTemplates, template]);
    }
  };

  // Save the selected templates as new linked work orders
  const handleSave = () => {
    if (!sale) {
      console.error("Cannot save work orders without a valid sale.");
      return;
    }

    const newLinkedWorkOrders = [
      ...linkedWorkOrders,
      ...selectedTemplates.map((template) => ({
        id: template.id,
        name: template.name,
        status: "Pending", // Default status for newly linked work orders
      })),
    ];

    // Pass the updated linked work orders to the parent component
    onSave(newLinkedWorkOrders);
  };

  if (!sale) return null;

  return (
    <div className="fixed top-0 right-0 w-full md:w-1/3 h-full bg-white shadow-lg z-50 flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center p-4 border-b bg-gray-100">
        <h2 className="text-xl font-bold text-gray-800">Link Work Orders</h2>
        <button
          className="text-gray-600 hover:text-gray-900 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto p-6 space-y-6">
        {/* Available Work Order Templates */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Available Work Order Templates</h3>
          <ul className="space-y-3">
            {workOrderTemplates.map((template) => (
              <li key={template.id} className="flex items-center space-x-4">
                <input
                  type="checkbox"
                  checked={selectedTemplates.some((t) => t.id === template.id)}
                  onChange={() => toggleTemplateSelection(template)}
                  className="w-4 h-4"
                />
                <p className="font-medium">{template.name}</p>
              </li>
            ))}
          </ul>
        </div>

        {/* Linked Work Orders */}
        <div>
          <h3 className="text-lg font-semibold mb-4">Linked Work Orders</h3>
          {linkedWorkOrders.length > 0 ? (
            <ul className="space-y-3">
              {linkedWorkOrders.map((workOrder) => (
                <li
                  key={workOrder.id}
                  className="flex items-center justify-between p-3 bg-gray-100 rounded-md"
                >
                  <div>
                    <p className="font-medium">{workOrder.name}</p>
                    <p className="text-sm text-gray-600">Status: {workOrder.status}</p>
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-gray-500">No work orders linked to this sale yet.</p>
          )}
        </div>
      </div>

      {/* Sticky Footer */}
      <div className="p-4 border-t bg-gray-100 flex justify-end space-x-4">
        <button
          onClick={onClose}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default LinkWorkOrderModal;